import React, { useContext } from 'react';
import { PageEditorStoreContext } from '../store/PageEditorStore';
import ComponentItemRender from './ComponentItemRender';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';

const PageContentRender = observer(() => {
  const pageEditorStore = useContext(PageEditorStoreContext);

  return (
    <div>
      {pageEditorStore?.page[pageEditorStore.model]?.map((item) => {
        return <ComponentItemRender key={item.nodeId} {...toJS(item)} />;
      })}
    </div>
  );
});

export default PageContentRender;
